// Safari 3.0+ "[object HTMLElementConstructor]" 
const _isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof window['safari'] !== 'undefined' && window['safari']['pushNotification']));

// Opera 8.0+
const _isOpera = (!!window['opr'] && !!window['opr'].addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
const _isFirefox = typeof InstallTrigger !== 'undefined';

// Internet Explorer 6-11
const _isIE = /*@cc_on!@*/false || !!document.documentMode;

// Edge 20+
const _isEdge = !_isIE && !!window.StyleMedia;

// Chrome 1+
const _isChrome = !!window.chrome && !!window.chrome.webstore;

// Blink engine detection
const _isBlink = (_isChrome || _isOpera) && !!window.CSS;

// Any mobile devide by user agent
const _isPhone = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const _canvasReduction = 15;

export {
    _getBrowserType as getType,
    _getCanvasLimits as getCanvasLimits,
    _isInCanvasLimits as isInCanvasLimits,
    _getNewScale as getAcceptableScale,
    _isPhoneBrowser as isPhone
};

function _getBrowserType() {
    if (_isSafari)
        return "Safari";
    else if (_isOpera)
        return "Opera";
    else if (_isFirefox)
        return "Firefox";
    else if (_isIE)
        return "IE";
    else if (_isEdge)
        return "Edge"
    else if (_isChrome)
        return "Chrome";
    else if (_isBlink)
        return "Blink";

    return "N/A";
}

function _getCanvasLimits() {
    if (_isPhone)
        return _getPhoneLimist();

    return _getDesktopLimits();
}

function _isPhoneBrowser() {
    return _isPhone;
}

function _getPhoneLimist() { 
    let limits = { 
        width: 4096 - _canvasReduction,
        height: 4096 - _canvasReduction,
        area: (2048 - _canvasReduction)*(2048 - _canvasReduction)
    }

    return limits;
}

function _getDesktopLimits() {
    let limits = { 
        width: 8192 - _canvasReduction,
        height: 8192 - _canvasReduction,
        area: (4096 - _canvasReduction)*(4096 - _canvasReduction)
    }

    if (_isChrome) { 
        limits.width = 32767 - _canvasReduction; 
        limits.height = 32767 - _canvasReduction;
        limits.area = 268435456 - (_canvasReduction*_canvasReduction); 
    } //area e.g. (16384-15) * (16384-15)
    if (_isFirefox) { 
        limits.width = 32767 - _canvasReduction; 
        limits.height = 32767 - _canvasReduction;
        limits.area = 472907776 - (_canvasReduction*_canvasReduction); 
    } //area e.g. (22528-15) * (20992-15)
    
    return limits;
}

function _isInCanvasLimits(neededWidth, neededHeight) {
    let cl = _getCanvasLimits();

    return neededWidth < cl.width && neededHeight < cl.height && (neededWidth * neededHeight) < cl.area;
}

function _getNewScale(neededWidth, neededHeight) {
    let ratio = 1;
    let cl = _getCanvasLimits();
    if (neededWidth > cl.width) {
        ratio = ratio * (cl.width / neededWidth);
        neededWidth = neededWidth * ratio;
        neededHeight = neededHeight * ratio;
    }

    if (neededHeight > cl.height) {
        ratio = ratio * (cl.height / neededHeight);
        neededHeight = neededHeight * ratio;
        neededWidth = neededWidth * ratio;
    }

    if (neededWidth * neededHeight > cl.area) {
        ratio = ratio * (cl.area / (neededWidth * neededHeight));
    }

    return ratio;
}